<template>
	<div>
		<div style="margin-top: 60px;" v-if="mg_flag"></div>
		<div class="flex-box">
			<div class="flex-box-bd"></div>
			<div>
				<div class="tcenter"><img class="width-200" :src="$config.imgUrlCom+'no_data.png'"></div>
				<div class="text-gray">{{title || $t('search_nodata')}}</div>
			</div>
			<div class="flex-box-bd"></div>
		</div>
		<div><slot></slot></div>
	</div>
</template>

<script>
    export default {
        props:{
            title:{
                type: String,
                default: ''
            },
			mg_flag:{
				default:true
			}
		}
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/myNodata.vue